import { BuyNowService } from '../services/buy-now.service';
import { Component, OnDestroy, OnInit } from '@angular/core';
import { LocalStorageService } from '../services/local-storage.service';
import { FirestoreProductsService } from '../services/firestore-products.service';
import { NavService } from '../../shop/services/nav.service';
import { PricesService } from '../services/prices.service';
import { ProductRangeService } from '../services/product-range.service';
import { Router } from '@angular/router';
import { Subscription } from 'rxjs';
import { TransformTextService } from '../services/transform-text.service';

@Component({
  selector: 'app-cart-menu',
  styleUrls: ['./cart-menu.component.scss'],
  templateUrl: './cart-menu.component.html'
})

export class CartMenuComponent implements OnDestroy, OnInit {

  private collection: string;
  private collectionChild: string;
  private concreteTop: boolean;
  private cost: number;
  private count: string;
  private countLs: string;
  private countArray: number[] = [];
  private countNum: number;
  private countVal: string;
  private delivery: number;
  private depth: number;
  private discount: number;
  private glassTop: boolean;
  private isSingle: boolean;
  private filteredProducts: any;
  private isRectangleTable: boolean;
  private marbleTop: boolean;
  private markup: number;
  private monthArray: number[];
  private monthlyPrice: number;
  private monthsTotal: number[] = [];
  private myCount: string;
  private nameList: string[] = [];
  private ownDiscount: number;
  private price: number;
  private priceArray: number[] = [];
  private prodCost: string;
  private prodId: string;
  private products: any[];
  private productsHolder: any[];
  private productList: object;
  private productSku: string;
  private renewDiscount: number;
  private routerVal: string;
  private selections: string;
  private selectionsTitle: string;
  private skuArray: string;
  private subTotal: number;
  private tableTopSelection: string;
  private tableSize: string;
  private tax: number;
  private topCost: number;
  private totaPrices: number;
  private width: number;
  private woodTop: boolean;

  public area: string;
  public areaState: boolean;
  public buyState: boolean;
  public cartBool: boolean;
  public countTotal: number;
  public months: string;
  public monthEval: number;
  public monthState: boolean;
  public nameVal: string;
  public subscription: Subscription;
  http: any;

  constructor(
    private buyNow: BuyNowService,
    private fsProducts: FirestoreProductsService,
    private navState: NavService,
    private pricesService: PricesService,
    private productRange: ProductRangeService,
    private titleCaseService: TransformTextService,

    public ls: LocalStorageService,
    public router: Router
  ) {
    this.buyState = false;
    this.navState.openNav(false);

    this.subcribeArea();
    this.subcribeCount();
    this.subscribeCosts();
    this.subcribeMonth();
    this.subcribeProduct();
    this.subscribeNavState();
    this.subscribeSelection();

    // Buy State
    this.subscription = this.buyNow.getStatus().subscribe(status => this.buyState = status);

    // this.billdozer.post('/billdozer');
    // this.billdozer.get('/billdozerGetUrl');
  }

  ngOnInit() {
    this.monthArray = [
      13, 12, 11, 10, 9, 8, 7, 6, 5, 4, 3, 2, 1
    ];

    this.catFilter();
    this.initCount();
    this.initCustomVals();
    this.initLsValues();
    this.initPriceConstants();
    this.initProducts();
    this.initSelections();
    this.getSubTotal();
  }

  ngOnDestroy() {
    this.subscription.unsubscribe();
    this.subcribeArea();
    this.subcribeCount();
    this.subscribeCosts();
    this.subcribeMonth();
    this.subcribeProduct();
    this.subscribeSelection();
  }

  private basicMonthPrice(cost: number, name: string): number {
    const retailPrice = this.sellingPrice(cost);
    const count = this.getCount(name);

    this.monthlyPrice = this.pricesService.monthlySubscriptionPrices(this.discount, this.monthEval, retailPrice);

    return this.monthlyPrice * count;
  }

  private buyProduct(set: boolean): void {
    this.buyNow.setBuy(set);
  }

  private catFilter(): void {
    const tempVal: string[] = this.router.url.split('/');
    this.routerVal = tempVal[3];
    this.collection = tempVal[1];
    this.collectionChild = tempVal[2];
    if (this.collection === 'collections') {
      this.isSingle = false;
    } else {
      this.isSingle = true;
    }
  }

  private checkIndex(name: string): boolean {
    console.log(name);
    console.log(this.selections); 
    if (this.selections.indexOf(name) > -1) {
      return true;
    } else if (this.selections.indexOf(name) === -1) {
      return false;
    } else {
      console.error(Error, 'encountered an error');
    }
  }

  public clearMonth(): void {
    const month = document.getElementsByClassName('month-child');
    for (let i = 0; i < month.length; i++) {
      month[i].classList.contains('selected');
      month[i].classList.remove('selected');
    }
  }

  private filterBy(key: string, value: string): void {
    this.filteredProducts = this.fsProducts.filterBy(key, value).subscribe(document => {
      // console.log(document);
      this.productRange.castBaseStamp(document);
      this.subscribeProductRange();
    });
  }

  public getArea(event): void {
    const dataVal = event.srcElement.id;
    const cartArea = document.getElementsByClassName('cart-area');

    for (let i = 0; i < cartArea.length; i++) {
      cartArea[i].classList.remove('selected');
    }

    event.srcElement.classList.add('selected');
    this.ls.areaWrite(dataVal);

    // const prodPrices = localStorage.getItem('productsPrice');
    // if (prodPrices !== null || prodPrices !== undefined) {
    //   this.ls.priceWrite(prodPrices);
    // }
  }

  private getCosts(cost: number): number {
    let monthlyPrice: number;

    if (this.countNum > 0) {
      monthlyPrice = this.countNum * (this.basicMonthPrice(cost, this.nameVal));
    } else {
      monthlyPrice = this.basicMonthPrice(cost, this.nameVal);
    }

    if (this.monthsTotal.indexOf(monthlyPrice) === -1) {
      if (monthlyPrice > 0) {
        this.monthsTotal.push(monthlyPrice);
        console.log(this.monthsTotal);
      }
    }
    // this.subTotal = this.monthsTotal.reduce((a, b) => a + b, 0);
    return monthlyPrice;
  }

  private getCount(name: string) {
    return this.ls.getCount(name);
  }

  public getMonth(event): void {
    const dataVal: string = event.srcElement.dataset.indexNumber;
    const cartMonth = document.getElementsByClassName('cart-month');

    for (let i = 0; i < cartMonth.length; i++) {
      cartMonth[i].classList.remove('selected');
    }

    event.srcElement.classList.add('selected');
    this.sendMonth(dataVal);

    // const prodPrices = localStorage.getItem('productsPrice');
    // if (prodPrices !== null || prodPrices !== undefined) {
    //   this.ls.priceWrite(prodPrices);
    // }
  }

  private getSubTotal() {
    const costs: string[] = this.prodCost.split(' ');
    const costArray: number[] = [];
    let singleCost: number;

    for (let i = 0; i < costs.length; i++) {
      singleCost = this.pricesService.monthlySubscriptionPrices(this.discount, this.monthEval, parseFloat(costs[i].split('_')[1]));
      costArray.push(singleCost);
    }

    this.subTotal = costArray.reduce((a, b) => a + b, 0);
    console.log(this.subTotal);
  }

  private getSelections(name: string, selectionsArray: string): string {
    // console.log(selectionsArray);
    const checkArray: string[] = selectionsArray.split(' ');
    for (let i = 0; i < checkArray.length; i++) {
      if (checkArray[i].indexOf(name) > -1) {
        const returnArray = checkArray[i].split('_')[1];
        return returnArray.split('.').join('<br>');
      }
    }
  }

  private getTitleCase(string: string): string {
    return this.titleCaseService.newName(string);
  }

  private initCount(): void {
    const count: string = localStorage.getItem('productCount');

    if (count === null || count === undefined) {
      this.countTotal = 0;
    } else {
      const counts: string[] = localStorage.getItem('productCount').split(' ');

      for (let i = 0; i < counts.length; i++) {
        const tempSplit = counts[i].split('_');
        this.ls.countWrite(tempSplit[1], tempSplit[0]);
      }
    }
  }

  private initCustomVals(): void {
    this.subTotal = 0;
    // this.areaState = false;
    // this.openState = false;

    this.concreteTop = true;
    this.glassTop = false;
    this.marbleTop = false;
    this.woodTop = false;
    this.countTotal = 0;
    this.tableSize = '4-6';
    this.tableTopSelection = 'concrete';


    if (this.isRectangleTable === true) {
      this.depth = 900;
      this.width = 1200;
    } else {
      this.depth = 1200;
      this.width = 1200;
    }
  }

  private initLsValues(): void {
    if (localStorage.getItem('monthSelection')) {
      this.ls.monthWrite(localStorage.getItem('monthSelection'));
    } else {
      this.ls.monthWrite('12');
    }

    if (localStorage.getItem('areaSelection')) {
      this.area = localStorage.getItem('areaSelection');
      this.ls.areaWrite(this.area);
      this.ls.areaSend(true);
    }
  }

  private initPriceConstants(): void {
    this.cost = 0;
    this.delivery = this.pricesService.delivery;
    this.discount = this.pricesService.discount;
    this.markup = this.pricesService.markup;
    this.monthEval = 0;
    this.ownDiscount = this.pricesService.ownDiscount;
    this.renewDiscount = this.pricesService.renewDiscount;
    this.tax = this.pricesService.taxVal;
  }

  private initProducts(): void {
    const products: string = localStorage.getItem('productSelection');
    if (products !== null) {
      if (products.indexOf(' ') === -1) {
        this.ls.productWriteNew(products);
      } else {
        const nameSplit: string[] = localStorage.productSelection.split(' ');
        for (let i = 0; i < nameSplit.length; i++) {
          this.ls.productWriteNew(nameSplit[i]);
        }
      }
    }
  }

  private initSelections(): void {
    if (localStorage.selections) {
      this.ls.selectionsObs.next(localStorage.selections);
    }
  }

  private monthPrice(cost: number, name: string): number {
    let countVal: number;

    if (this.countLs === null || this.countLs === undefined) {
      const retailPrice = this.sellingPrice(cost);
      this.monthlyPrice = this.pricesService.monthlySubscriptionPrices(this.discount, this.monthEval, retailPrice);
      return this.monthlyPrice;
    } else {

      if (this.countLs.indexOf(name) > -1) {
        const countSplit = this.count.split(' ');

        let matchCount: string[];
        let stringCount: string;

        for (let i = 0; i < countSplit.length; i++) {
          if (countSplit[i].indexOf(name) > -1) {
            matchCount = countSplit[i].split('-');
            stringCount = matchCount[matchCount.length - 1];
            countVal = parseFloat(stringCount);
          }
        }
      } else if (this.countLs.indexOf(name) === -1) {
        countVal = 1;
      } else {
        console.error('Unknown error: \n' + 'cost: ' + cost + '\nname: ' + name);
      }

      const retailPrice = this.sellingPrice(cost * countVal);
      this.monthlyPrice = this.pricesService.monthlySubscriptionPrices(this.discount, this.monthEval, retailPrice);

      return this.monthlyPrice;
    }
  }

  public openArea(): void {
    this.areaState = !this.areaState;
  }

  public openMonth(): void {
    this.monthState = !this.monthState;
  }

  private productsRemove(event): void {
    const name: string = event.srcElement.dataset.indexNumber;
    const returnProduct: boolean = this.ls.removeProduct(name);
    const prodName: string = localStorage.getItem('productSelection');

    this.ls.removeSelection(name);
    this.ls.removePrice(name);
    this.ls.removeCount(name);

    // Rest sub total
    this.monthsTotal = [];

    if (returnProduct === false) {
      this.products = [];
      this.ls.prodObs.next(prodName);
      if (returnProduct === null) {
        this.ls.prodObs.next('');
        this.countTotal = 0;
      } else if (returnProduct !== null) {
        this.ls.prodObs.next(prodName);
      }
      // this.ls.removeCount(name);
    } else if (returnProduct === true) {
      if (returnProduct === null) {
        this.ls.prodObs.next('');
        this.countTotal = 0;
      } else if (returnProduct !== null) {
        const prodArray = prodName.split(' ');
        for (let i = 0; i < prodArray.length; i++) {
          this.filterBy('name', prodArray[i]);
          this.productWrite(prodArray[i]);
        }
      }
      this.products = [];
      // this.subTotal = 0;
    } else if (returnProduct === null) {
      this.products = [];
      // this.subTotal = 0;
      // this.countTotal = 0;
    }

    const pricesArray = localStorage.productsPrice.split(' ');
  }

  private productWrite(name): void {
    this.ls.productWrite(name);
  }

  private sellingPrice(cost: number): number {
    if (this.collectionChild === 'dining-tables') {
      let depth = this.depth;
      let width = this.width;

      if (this.isRectangleTable === true) {
        if (this.tableSize === '4-6') {
          depth = 900;
          width = 1200;
        } else if (this.tableSize === '6-8') {
          depth = 2000;
          width = 1000;
        } else if (this.tableSize === '8-10') {
          depth = 2750;
          width = 1200;
        }
      } else if (this.isRectangleTable === false) {
        if (this.tableSize === '4-6') {
          depth = 1200;
          width = 1200;
        } else if (this.tableSize === '6-8') {
          depth = 1500;
          width = 1500;
        }
      }

      this.price = this.pricesService.tableSellingPrice(cost, this.delivery, depth, this.markup, this.isRectangleTable, this.tableSize, this.topCost, this.tax, width);

      return this.price;
    } else if (this.collectionChild !== 'dining-tables') {

      this.price = this.price = this.pricesService.sellingPrice(cost, this.delivery, this.markup, this.tax);
      return this.price;
    }
  }

  private sendCount(count: string, name: string): void {
    this.ls.countWrite(count, name);
  }

  private sendMonth(month: string): void {
    this.ls.monthWrite(month);
  }

  private setCount(): void {

    if (this.countLs === null || this.countLs === undefined) {
      console.log('no value');
    } else {
      const counts: string[] = this.countLs.split(' ');

      for (let i = 0; i < counts.length; i++) {
        const tempCount: string[] = counts[i].split('_');
        this.countVal = tempCount[1];
        this.prodId = tempCount[0];
      }
    }
  }

  private start(): void {
    this.cartBool = !this.cartBool;
    this.navState.openNav(true);
  }

  public subcribeCount(): void {
    this.subscription = this.ls.countListener().subscribe(count => {
      this.count = count;
      this.countLs = localStorage.getItem('productCount');
      this.setCount();
      this.countTotal = this.ls.getTotalCounts();
    });
  }

  public subcribeArea(): void {
    this.subscription = this.ls.areaListener().subscribe(area => {
      if (area) {
        this.area = area;
        console.log(area);
        // this.areaVal = Object.values(area);
      }
   });
  }

  public subcribeMonth(): void {
    this.subscription = this.ls.monthListener().subscribe(month => {
      console.log(month);
      if (month) {
        this.monthEval = parseFloat(month);
        this.months = month;
      } else {
        this.monthEval = 0;
        this.months = null;
      }
    });
  }

  public subscribeNavState(): void {
    this.navState.getStatus().subscribe(boolean => this.cartBool = boolean);
  }

  public subscribeCosts(): void {
    this.ls.productPriceListener().subscribe(costs => {
      this.prodCost = costs;
      this.getSubTotal();
    });
  }

  public subcribeProduct(): void {
    this.subscription = this.ls.productListener().subscribe(name => {
      if (name !== null || name !== undefined) {
        this.nameVal = name;
        this.filterBy('name', name);
        this.nameList.push(name);
      } else {
        this.nameVal = '';
        this.countTotal = 0;
      }
    });
  }
 
  public subscribeProductRange(): void {
    this.productRange.productObs().subscribe((document: any[]) => {
      console.log(document);
      if (this.products === null || this.products === undefined) {
        this.products = document;
        this.getCosts(document[0].baseCost);
        let costPrice = 0;
        for (let i = 0; i < this.products.length; i++) {
          costPrice = costPrice + this.products[i].baseCost;
        }
      } else {
        const prodName = document[0].name;
        if (this.products.indexOf(prodName) === -1) {
          this.products.push(document[0]);
        }
      }
      console.log(this.products);
    });
  }

  public subscribeSelection(): void {
    this.ls.selectionListener().subscribe(selections => {
      this.selections = selections;
    });
  }

  private thisPrice(name: string) {
    if (this.monthEval > 0) {
      const prodCount = this.ls.getCount(name);
      const prodPrice = this.ls.getProductCost(name);
      const monthlyPrice = this.pricesService.monthlySubscriptionPrices(this.discount, this.monthEval, prodPrice);
      const newPrice = prodCount * monthlyPrice;

      this.priceArray.push(newPrice);
      return newPrice;
    } else if (this.monthEval === 0) {
      return this.ls.getProductCost(name);
    }
  }

  private thisPriceSingle(name: string) {
    const prodPrice = this.ls.getProductCost(name);
    return this.pricesService.monthlySubscriptionPrices(this.discount, this.monthEval, prodPrice);
  }

  public toggleSearch(): void {
    this.cartBool = !this.cartBool;
  }
}
